import { render, staticRenderFns } from "./BookHarvest.vue?vue&type=template&id=524bc522&"
import script from "./BookHarvest.vue?vue&type=script&lang=js&"
export * from "./BookHarvest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports